/** Вид цены общего каталога: `sourceResourceId` — база, чья это цена; `key` — то, что хранится в настройках. */
export interface OwnPriceType {
  name: string
  sourceResourceId: string
  key: string
}

function fail(field: string): never {
  throw new Error(`Ответ сервера не по договору: ${field}`)
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

/** `GET catalog/price-types`: «Цена кассы» (без ключа) в подсказку не входит — её даёт пустое значение. */
export function decodePriceTypes(raw: unknown): readonly OwnPriceType[] {
  if (!isRecord(raw) || !Array.isArray(raw.items)) return fail('виды цен')
  const types: OwnPriceType[] = []
  raw.items.forEach((item: unknown, index: number) => {
    if (!isRecord(item) || typeof item.name !== 'string') return fail(`items[${index}]`)
    if (typeof item.key === 'string' && item.key !== '' && typeof item.sourceResourceId === 'string' && item.sourceResourceId !== '')
      types.push({ name: item.name, sourceResourceId: item.sourceResourceId, key: item.key })
  })
  return types
}
